<template>
    <div class="wizard-step">
        <div class="wizard-step__inner">
            <div class="wizard-step-head wizard-step-head_full pt-0 mb-24">
                <div class="wizard-step-head__inner">
                    <div class="container">
                        <el-row :gutter="12" type="flex" align="middle">
                            <el-col :span="12">
                                <h2 class="wizard-step-head__title">Указание общих компетенций</h2>
                            </el-col>

                            <el-col :span="6" :offset="4" class="wizard-step-head__grow">
                                <div class="wizard-step-head__extra">
                                    <v-select class="select" placeholder="Группировка" :value="groupItemsBy.label" :clearable="false" :options="groupQualificationsOpts" @input="setItemsGroup">
                                        <template #no-options="{ search, searching, loading }">
                                            {{ SELECT_NOT_FOUND }}
                                        </template>
                                        <template #open-indicator="{ attributes }">
                                            <span v-bind="attributes">
                                                <icon-base viewBox="0 0 14 8" class="select__arrow"><icon-arrow-down /></icon-base>
                                            </span>
                                        </template>
                                    </v-select>
                                </div>
                            </el-col>

                            <el-col :span="!IS_PANEL_OPEN ? 8 : 24">
                                <div class="wizard-step-head__extra">
                                    <form
                                        class="search-form wizard-step-head__grow"
                                        @submit.prevent
                                    >
                                        <div class="search-form__inner">
                                            <input type="search" class="input search-form__input" :class="{ 'search-form__input_reset': searchInput && searchInput.length !== 0 }" placeholder="Поиск" :disabled="!qualifications.length" v-model.trim="searchInput" @keydown.enter.prevent.stop>

                                            <button v-if="searchInput && searchInput.length !== 0" class="search-form__reset" @click="searchInput = ''">
                                                <icon-base viewBox="0 0 14 14"><icon-cancel /></icon-base>
                                            </button>

                                            <button type="submit" class="search-form__submit">
                                                <icon-base viewBox="0 0 24 24"><icon-search /></icon-base>
                                            </button>
                                        </div>
                                    </form>

                                    <button class="collapse-btn ml-12" @click="checkAccordions ? closeAccordions() : openAccordions()" :disabled="!qualifications.length">
                                        <icon-base viewBox="0 0 14 8" class="collapse-btn__icon" :class="{'collapse-btn__icon_active': !checkAccordions}"><icon-arrow-top /></icon-base>
                                    </button>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>

            <div class="container">
                <accordion v-if="groupQualifications.length">
                    <accordion-item ref="accordionItem" active parent highlighted v-for="(groupQualification, index) in groupQualifications" :bus="bus" :key="groupQualification.groupId">
                        <template #accordion-head>
                            <div tabindex="0" class="accordion__head">
                                <div class="accordion__head-item">
                                    <p class="accordion__title">{{ groupQualification.name }}</p>
                                </div>

                                <div class="accordion__head-item">
                                    <icon-base viewBox="0 0 14 8" class="accordion__arrow">
                                        <icon-arrow-down />
                                    </icon-base>
                                </div>
                            </div>
                        </template>

                        <accordion class="mt-16">
                            <accordion-item :bus="bus" v-for="(qualification, ind) in filteredItemsBySearch(groupQualification.items)" :key="qualification.kindId">
                                <template #accordion-head>
                                    <div class="accordion__head" tabindex="0">
                                        <div class="accordion__head-item">{{ qualification.name }}</div>

                                        <div class="accordion__head-item">
                                            <icon-base viewBox="0 0 14 8" class="accordion__arrow">
                                                <icon-arrow-down />
                                            </icon-base>
                                        </div>
                                    </div>
                                </template>

                                <el-table
                                    cell-class-name="table__cell"
                                    class="table table_top-scroll"
                                    header-cell-class-name="table__title"
                                    ref="kindsTables"
                                    row-key="id"
                                    :data="filteredInteriorItemsBySearch(qualification.items)"
                                    :sort-orders="['ascending', 'descending']"
                                >
                                    <el-table-column
                                        width="24"
                                        v-if="!read"
                                    >
                                        <template slot="header" slot-scope="scope">
                                            <div class="table_flex">
                                                <el-checkbox v-if="updateCheckboxAll" @change="toggleAllSelection(filteredInteriorItemsBySearch(qualification.items), qualification.kindId, $event)" :checked="selection[qualification.kindId] ? filteredInteriorItemsBySearch(qualification.items).length === selection[qualification.kindId].length : false" />
                                            </div>
                                        </template>
                                        <template slot-scope="scope">
                                            <div class="table_flex">
                                                <el-checkbox v-if="updateCheckbox" @change="handleSelectionChange([scope.row], qualification.kindId, $event)" :checked="handleSelectionValue([scope.row], qualification.kindId)" />
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        width="48"
                                    >
                                        <template slot="header" slot-scope="scope">
                                            <button type="button" class="settings-btn-main" @click="elDialogs.tableSettings = true">
                                                <icon-base viewBox="0 0 14 14" class="settings-btn__icon"><icon-settings-main /></icon-base>
                                            </button>
                                        </template>

                                        <template v-if="!read" slot-scope="scope">
                                            <selector-btn :options="accordionTableOptionsForBtn" :params="{ index: ind, groupId: qualification.kindId, curId: scope.row.id }" portal="selectorModal" @clickOnItem="callback"></selector-btn>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        label="Код"
                                        prop="code"
                                        sortable
                                        min-width="100"
                                        v-if="qualificationsSettings.find((item) => item.name === 'code' && item.visible)"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        label="Название ПК"
                                        prop="name"
                                        sortable
                                        :min-width="400"
                                    >
                                        <template slot="header" slot-scope="scope">
                                            <span :forceUpdate="forceUpdate" v-if="!selection[qualification.kindId] || (selection[qualification.kindId] && !selection[qualification.kindId].length)">Название ПК</span>

                                            <button :forceUpdate="forceUpdate" type="button" class="btn btn_danger-second btn_small" v-if="selection[qualification.kindId] && selection[qualification.kindId].length" @click.stop="deleteItems({ index: index, groupId: qualification.kindId })">
                                                Удалить выбранные
                                            </button>
                                        </template>

                                        <template slot-scope="scope">
                                            <a href="#" v-html="scope.row.name" @click.prevent.stop="openCompetences(scope.row)"></a>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        label="Уровень"
                                        prop="level"
                                        sortable
                                        min-width="100"
                                        v-if="qualificationsSettings.find((item) => item.name === 'level' && item.visible)"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        label="Название стандарта"
                                        prop="standard_name"
                                        sortable
                                        min-width="300"
                                        v-if="qualificationsSettings.find((item) => item.name === 'standard_name' && item.visible)"
                                    >
                                        <template slot-scope="scope">
                                            <span v-html="GET_KIND_BY_ID(scope.row.kind_id).standard_name"></span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column
                                        label="Soft Skills"
                                        prop="soft_skills"
                                        sortable
                                        align="center"
                                        :width="90"
                                        v-if="qualificationsSettings.find((item) => item.name === 'soft_skills' && item.visible)"
                                    >
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.hasOwnProperty('soft_skills')" v-html="scope.row.soft_skills ? scope.row.soft_skills : 0"></span>
                                            <local-preloader v-else mini />
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        label="Hard Skills"
                                        prop="hard_skills"
                                        sortable
                                        align="center"
                                        :width="90"
                                        v-if="qualificationsSettings.find((item) => item.name === 'hard_skills' && item.visible)"
                                    >
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.hasOwnProperty('hard_skills')" v-html="scope.row.hard_skills ? scope.row.hard_skills : 0"></span>
                                            <local-preloader v-else mini />
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        label="Статус"
                                        prop="work_functions"
                                        sortable
                                        align="center"
                                        :width="200"
                                        v-if="qualificationsSettings.find((item) => item.name === 'status' && item.visible)"
                                    >
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.status_id" class="status" :class="{ [ STATUSES_DICT[scope.row.status_id].cls ]: true }" v-html="STATUSES_DICT[scope.row.status_id].text"></span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </accordion-item>
                        </accordion>
                    </accordion-item>
                </accordion>
            </div>
        </div>

        <reference-button v-if="hintsCode" :hasFooter="hasFooter" :hintsCode="hintsCode" :content="hints.content" />

        <!-- DIALOGS -->
        <table-settings-dialog :settings="qualificationsSettings" @saveTableSettings="changeTableColums" />

        <!-- PANELS -->
        <competences-panel :read="read" :qualificationId="activeItemId" :kindId="activeItemKindId" v-if="activeItemId" @changeActiveSkills="(skillName) => activeSkills = skillName" />
        <!-- /PANELS -->
    </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import constants from '@/constants.js';
import step from '@/mixins/step';

import Accordion from '@/components/Accordion/Accordion';
import AccordionItem from '@/components/Accordion/AccordionItem';
import CompetencesPanel from '@/components/WizardPanels/CompetencesPanel';
import TableSettingsDialog from '@/components/Dialogs/TableSettingsDialog';
import Tab from '@/components/Tabs/Tab';
import Tabs from '@/components/Tabs/Tabs';
import SelectorBtn from '@/components/SelectorBtn';
import LocalPreloader from '../LocalPreloader.vue';
import ReferenceButton from "../ReferenceButton";

export default {
    mixins: [ step ],
    components: {
        Accordion,
        AccordionItem,
        CompetencesPanel,
        TableSettingsDialog,
        Tab,
        Tabs,
        SelectorBtn,
        LocalPreloader,
        ReferenceButton,
    },
    props: {
        read: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            bus: new Vue(),
            isMounted: false,
            forceUpdate: 1,
            updateCheckbox: true,
            updateCheckboxAll: true,

            searchValue: null,
            activeItemId: null,
            activeItemKindId: null,
            searchKindsValue: null,
            selection: {},
            hasFooter: true,
            hintsCode: 'CompetencesStep',
            activeSkills: '',

            qualificationsSettings: [
                {
                    name: 'code',
                    title: 'Код',
                    visible: false,
                    default: false
                },
                {
                    name: 'name',
                    required: true,
                    title: 'Название',
                    visible: true,
                    default: true
                },
                {
                    name: 'level',
                    title: 'Уровень',
                    visible: false,
                    default: false
                },
                {
                    name: 'standard_name',
                    title: 'Название стандарта',
                    visible: false,
                    default: false
                },
                {
                    name: 'soft_skills',
                    title: 'Soft Skills',
                    visible: true,
                    default: true
                },
                {
                    name: 'hard_skills',
                    title: 'Hard Skills',
                    visible: true,
                    default: true
                },
                {
                    name: 'status',
                    title: 'Статус',
                    visible: true,
                    default: true
                },
            ],
            groupQualificationsOpts: [
                {
                    name: 'area_id',
                    label: 'По ОПД'
                },
                {
                    name: 'lifecycle_id',
                    label: 'По жизненному циклу'
                }
            ],
            accordionTableOptionsForBtn: [
                {
                    name: 'Удалить',
                    warning: true,
                    callback: 'deleteItems'
                }
            ]
        }
    },
    methods: {
        ...mapActions('editor', [
            'LOAD_QUALIFICATIONS',
            'LOAD_COMPETENCES',
            'LOAD_HARD_SKILLS_BY_QUALIFICATION',
            'LOAD_SOFT_SKILLS_BY_QUALIFICATION',
            'LOAD_HARD_SKILLS',
            'LOAD_SOFT_SKILLS',
            'DELETE_QUALIFICATIONS',
        ]),
        ...mapActions('loader', ['show', 'hide']),
        ...mapActions('hints', [
            'LOAD_HINTS',
        ]),
        ...mapMutations('common', ['TOGGLE_DIALOG', 'TOGGLE_PANEL']),
        ...mapMutations('editor', ['GROUP_QUALIFICATIONS', 'SET_ITEMS_GROUP']),

        closeAccordions() {
            this.bus.$emit('closeAccordion');
        },
        openAccordions() {
            this.show()
            setTimeout(() => {
                this.bus.$emit('openAccordion');
                this.$nextTick(() => {
                    this.bus.$emit('openAccordion');
                    this.$nextTick(() => {
                        this.hide()
                    })
                })
            }, 0);
        },

        handleSelectionChange(val, parentId, event) {
            if (event) this.selection[parentId] = [...val, ...(this.selection[parentId] ? this.selection[parentId] : [])];
            else {
                this.selection[parentId] = this.selection[parentId].filter(select => !val.find(item => item.id === select.id))
                if (this.selection[parentId].length === 0) delete this.selection[parentId]
            }
            this.forceUpdate++
            this.forceRerenderCheckboxAll()
        },
        toggleAllSelection(val, parentId, event) {
            if (event) this.selection[parentId] = [...val];
            else delete this.selection[parentId]
            this.forceUpdate++
            this.forceRerenderCheckbox()
        },
        handleSelectionValue(val, parentId) {
            return this.selection[parentId] ? !!this.selection[parentId].filter(select => val.find(item => item.id === select.id)).length : false
        },
        forceRerenderCheckbox() {
            this.updateCheckbox = false;

            this.$nextTick(() => {
                this.updateCheckbox = true;
            });
        },
        forceRerenderCheckboxAll() {
            this.updateCheckboxAll = false;

            this.$nextTick(() => {
                this.updateCheckboxAll = true;
            });
        },

        callback(emitObj) {
            this[emitObj.callback](emitObj.args)
        },
        changeTableColums(settings) {
            this.qualificationsSettings = settings
        },

        async deleteItems({ index, groupId, curId }) {
            if (curId) await this.DELETE_QUALIFICATIONS(curId);
            else await this.DELETE_QUALIFICATIONS(this.selection[groupId].map((item) => item.id));

            this.GROUP_QUALIFICATIONS(this.groupItemsBy.name);
            delete this.selection[groupId];
            this.forceUpdate++
        },
        async openCompetences(qualification) {
            this.activeItemId = qualification.id;
            this.activeItemKindId = qualification.kind_id;
                
            await Promise.all([
                this.LOAD_HARD_SKILLS(qualification.id),
                this.LOAD_SOFT_SKILLS(qualification.id),
                this.LOAD_COMPETENCES(),
                this.LOAD_HARD_SKILLS_BY_QUALIFICATION(qualification.id),
                this.LOAD_SOFT_SKILLS_BY_QUALIFICATION(qualification.id)
            ]);

            this.elPanels.competences = 1;
        },
        setItemsGroup(value) {
            this.SET_ITEMS_GROUP(value);
            this.GROUP_QUALIFICATIONS(value.name);
        },
        filteredItemsBySearch(items) {
            return this.searchInput ? items.filter(item => item.items.filter(interiorItem => interiorItem.name.toLowerCase().includes(this.searchInput.toLowerCase())).length > 0) : items
        },
        filteredInteriorItemsBySearch(items) {
            const tempItems = [].concat(items)
            return this.searchInput ? tempItems.filter(item => item.name.toLowerCase().includes(this.searchInput.toLowerCase())) : tempItems
        }
    },
    computed: {
        ...mapGetters('common', ['IS_PANEL_OPEN']),
        ...mapGetters('editor', ['GET_AREA_BY_ID', 'GET_LIFECYCLE_BY_ID', 'GET_KIND_BY_ID']),
        ...mapState('common', ['dialogs', 'panels']),
        ...mapState('editor', ['groupItemsBy', 'groupQualifications', 'kinds', 'qualifications']),
        ...mapState('hints', ['hints']),

        checkAccordions() {
            if (!this.isMounted) return false
            else if (this.$refs.accordionItem.map(el => el.isActive).includes(true)) return true
            else return false
        }
    },
    watch: {
        searchInput: function() {
            this.forceRerenderCheckboxAll()
        },
        
        'elPanels.competences': function(val) {
            this.hasFooter = !val
            if (val === 1) this.hintsCode = 'CompetencesSkills'
            else if (val === 2 && this.activeSkills === 'softSkills') this.hintsCode = 'SoftSkills'
            else if (val === 2 && this.activeSkills === 'hardSkills') this.hintsCode = 'HardSkills'
            else this.hintsCode = 'CompetencesStep'
        }
    },
    created() {
        this.STATUSES_DICT = constants.STATUSES_DICT;
    },
    mounted() {
        this.isMounted = true;
    }
}
</script>
